export default __webpack_public_path__ + "static/media/132041237_321594068929715_272580533088292358_n.1cddead4.jpg";